import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ShopperInformation } from '@libs/feature-payments/static/interfaces/shopper-information.interface';

export const paymentActions = createActionGroup({
  source: 'Payment',
  events: {
    'Open link': props<{ linkId: string }>(),
    'Set link frozen': emptyProps(),
    'Submit shopper information': props<{ linkId: string; shopperInformation: Partial<ShopperInformation> }>(),
  },
});
